/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Haspassworddesc2Inputs */

const zh_password_haspassworddesc2 = /** @type {(inputs: Password_Haspassworddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您已设置密码。如需重置密码，我们将发送重置链接到您的邮箱。`)
};

const en_password_haspassworddesc2 = /** @type {(inputs: Password_Haspassworddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have set a password. To reset it, we will send a reset link to your email.`)
};

const es_password_haspassworddesc2 = /** @type {(inputs: Password_Haspassworddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya tienes una contraseña configurada. Para restablecerla, enviaremos un enlace a tu correo.`)
};

/**
* | output |
* | --- |
* | "You have set a password. To reset it, we will send a reset link to your email." |
*
* @param {Password_Haspassworddesc2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const password_haspassworddesc2 = /** @type {((inputs?: Password_Haspassworddesc2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Haspassworddesc2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_password_haspassworddesc2(inputs)
	if (locale === "en") return en_password_haspassworddesc2(inputs)
	return es_password_haspassworddesc2(inputs)
});
export { password_haspassworddesc2 as "password_hasPasswordDesc" }